import React, { useEffect, useState } from 'react';
import { client, urlFor } from '@/sanity/client';

export const AboutFounderImage: React.FC = () => {
	const [imageUrl, setImageUrl] = useState('');

	useEffect(() => {
		const fetchImage = async () => {
			const data = await client.fetch(
				`*[_type == "aboutPage"][0].founder.image`,
			);
			setImageUrl(urlFor(data).url());
		};

		fetchImage();
	}, []);

	return (
		<img
			src={imageUrl}
			alt='Founder portrait'
			className='object-contain grow w-full rounded-none aspect-[0.68] max-md:mt-10 max-md:max-w-full'
		/>
	);
};
